// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buy-modal {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: auto;
    min-width: 300px;
    max-width: 700px;
    /* height: 60px; */
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 15px;
    padding: 15px 20px;
    z-index: 100;
}

.buy-modal.dark {
    color: #121212;
}

.buy-modal.copy {
    border: 1px solid rgba(0, 9, 3, .08);
    background-color: #fff;
    box-shadow: 0 20px 25px -5px #0000001a, 0 10px 10px -5px #0000000a;
    animation: Modal_opacityIn .4s ease-in-out;
}

.buy-modal.copy.dark {
    border: 1px solid #cccccc16;
    background-color: #2b2c37;
    color: #fff;
    animation: Modal_opacityIn .4s ease-in-out;
}

@keyframes Modal_opacityIn {
    from {
        opacity: 0;
        transform: translate(-50%, -20px);
    }

    to {
        opacity: 1;
        transform: translate(-50%, 0px);
    }
}

.input-box {
    padding: 12px 15px !important;
}

.input-btn {
    padding: 5px 10px;
    background: rgba(239, 239, 239, 1);
    border-radius: 5px;
    cursor: pointer;
    font-size: 13px;
}

.main {
    width: 100vw;
    min-width: 1920px;
    height: 100vh;
    padding: 85px 20px 55px 220px;
}

/* member */
.member-1 {
    /* width: 100%; */
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
}

.member-1-search {
    width: 235px;
    height: 32px;
    border: 1px solid #dbdbdb;
    border-radius: 5px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.member-1-search.dark {
    background: #494848;
    color: #fff;
    border: 1px solid #3f3e3e;
}

.member-1-search input {
    width: 170px;
    height: 30px;
    background-color: #fff;
    border: none;
    outline: none;
}

.member-1-search.dark input {
    background: #494848;
    color: #fff;
}

.member-1-search-ico-1 {
    font-size: 15px;
    position: absolute;
    left: 10px;
}

.member-1-search-ico-2 {
    font-size: 15px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 10px;
    color: #a1a0a0;
    cursor: pointer;
}

.search-btn {
    padding: 0px 10px;
    height: 35px;
    font-size: 13px;
    border: 1px solid #dbdbdb;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: #fff;
}

.search-btn.dark {
    background: #494848;
    border: 1px solid #494848;
    color: #fff;
}

.search-btn:hover {
    background-color: #003577;
    color: #fff;
}

.member-1-select {
    width: 160px !important;
    height: 30px !important;
    border-radius: 5px;
    background-color: #fff;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    flex-direction: column;
    position: relative;
    cursor: pointer;
}

.member-2-select {
    width: 100px !important;
    height: 25px !important;
    border-radius: 5px;
    background-color: #fff;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    flex-direction: column;
    position: relative;
    cursor: pointer;
}

.member-1-select.dark,
.member-2-select.dark {
    background: #494848;
    color: #fff;
}

.member-1-select.border,
.member-2-select.border {
    border: 1px solid #e9e9e9;
}

.member-1-select.border.dark,
.member-1-select.border.dark {
    border: 1px solid #3f3e3e;
}

.member-1-select-1 {
    width: calc(100% - 15px) !important;
    text-align: left;
    padding-left: 5px;
    font-size: 14px;
    justify-content: flex-start !important;
    border: none !important;
}

.member-1-select svg,
.member-2-select svg {
    font-size: 18px;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #8b8b8b;
}

.member-1-select-box {
    position: absolute;
    width: 150px !important;
    height: auto !important;
    top: 33px;
    border: 1px solid #d9d9d9;
    background-color: #fff;
    border-radius: 5px;
    /* animation: member_drowdown .5s ease-in-out; */
    z-index: 31;
    flex-direction: column;
    align-items: flex-start !important;
    padding: 0 !important;
}

.member-2-select-box {
    position: absolute;
    width: 90px !important;
    height: auto !important;
    top: 33px;
    border: 1px solid #d9d9d9;
    background-color: #fff;
    border-radius: 5px;
    /* animation: member_drowdown .5s ease-in-out; */
    z-index: 31;
    flex-direction: column;
    align-items: flex-start !important;
    padding: 0 !important;
}

.member-3-select-box {
    position: absolute;
    width: calc(100% - 15px) !important;
    height: auto !important;
    top: 44px;
    border: 1px solid #d9d9d9;
    background-color: #fff;
    border-radius: 5px;
    /* animation: member_drowdown .5s ease-in-out; */
    z-index: 31;
    flex-direction: column;
    align-items: flex-start !important;
    padding: 0 !important;
    left: 50%;
    transform: translateX(-50%);
}

.member-1-select-box.dark,
.member-2-select-box.dark,
.member-3-select-box.dark,
.dashboard-1-select-box.dark,
.dashboard-2-select-box.dark {
    background: #494848;
    color: #fff;
    border: 1px solid #2f2f2f;
}

.member-1-select-box div,
.member-id-select-box div,
.member-2-select-box div,
.member-3-select-box div,
.dashboard-1-select-box div,
.dashboard-2-select-box div {
    text-align: left;
    padding: 8px 12px !important;
    font-size: 14px !important;
    justify-content: flex-start !important;
    border: none !important;
}

.member-1-select-box div:hover,
.member-id-select-box div:hover,
.member-2-select-box div:hover,
.member-3-select-box div:hover,
.dashboard-1-select-box div:hover,
.dashboard-2-select-box div:hover {
    background-color: #e9e9e9;
}

.member-1-select-box.dark div:hover,
.member-2-select-box.dark div:hover,
.member-3-select-box.dark div:hover,
.dashboard-1-select-box.dark div:hover,
.dashboard-2-select-box.dark div:hover {
    background-color: #5e5e5e;
}

.dashboard-1-select-box {
    position: absolute;
    width: 93px !important;
    height: auto !important;
    top: 33px;
    left: 0;
    border: 1px solid #d9d9d9;
    background-color: #fff;
    border-radius: 5px;
    /* animation: member_drowdown .5s ease-in-out; */
    z-index: 31;
    flex-direction: column;
    align-items: flex-start !important;
    color: #121212;
}

.dashboard-2-select-box {
    position: absolute;
    width: 72px !important;
    height: auto !important;
    top: 33px;
    left: 0;
    border: 1px solid #d9d9d9;
    background-color: #fff;
    border-radius: 5px;
    /* animation: member_drowdown .5s ease-in-out; */
    z-index: 31;
    flex-direction: column;
    align-items: flex-start !important;
    color: #121212;
}

@keyframes member_drowdown {
    from {
        opacity: 0.9;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.member-2-search {
    width: 380px;
    height: 35px;
    border: 1px solid #dbdbdb;
    border-radius: 5px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.member-2-search.dark {
    background: #494848;
    color: #fff;
    border: 1px solid #2f2f2f;
}

.member-2-search-1 {
    width: 200px;
    height: 30px;
    /* border: 1px solid #003577; */
    border-radius: 5px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 15px;
    position: relative;
}

.member-2-search-1.dark {
    background: #494848;
    color: #fff;
}

.member-2-search-1 input {
    width: 170px;
    height: 30px;
    background-color: #fff;
    border: none;
    outline: none;
}

.member-2-search-1.dark input {
    background: #494848;
    color: #fff;
}

.member-1-search-ico-3 {
    font-size: 15px;
    position: absolute;
    left: -5px;
}

.line {
    transform: rotate(90deg);
    font-size: 22px;
    color: #dbdbdb;
}

.member-2 {
    width: 100%;
    height: auto;
    margin-top: 15px;
    padding-bottom: 30px;
}

.member-2.dark {
    color: #dddbdb;
}

.table-head {
    padding-top: 10px;
    width: 100%;
    height: 47px;
    display: flex;
    align-items: center;
    /* justify-content: center; */
    border-bottom: 2px solid #000000;
    /* border-bottom: 2px solid rgba(237, 239, 241, 1); */
}

.table-head svg {
    cursor: pointer;
}

.table-head.dark {
    border-bottom: 2px solid #3f3e3e;
}

.table-head div {
    font-size: 13px;
    font-weight: bold;
    width: 100%;
    /* color: #636363; */
    position: relative;
    padding: 0 8px;
}

.table-head-dash {
    /* padding-top: 10px; */
    width: 100%;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 2px solid #000000;
    /* border-bottom: 2px solid rgba(237, 239, 241, 1); */
}

.table-head-dash.dark {
    border-bottom: 2px solid #3f3e3e;
}

.table-head-dash div {
    font-size: 14px;
    font-weight: bold;
    width: 100%;
    /* color: #636363; */
    padding: 0 10px;
}


.table-body {
    width: 100%;
    height: auto;
    position: relative;
    padding-bottom: 20px;
}

.table-body-tr {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid rgba(237, 239, 241, 1);
    display: flex;
    align-items: center;
    /* justify-content: center; */
    position: relative;
}

.table-body-tr.dark {
    border-bottom: 1px solid #3f3e3e;
    color: #bdbdbd;
}

.table-body-tr-1 {
    width: 30%;
    height: 30px;
    border-right: 1px solid rgba(237, 239, 241, 1);
}

.table-body-tr-1.dark {
    border-right: 1px solid #3f3e3e;
}

.table-body-tr .td {
    font-size: 12px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    border-left: 1px solid rgba(237, 239, 241, 1);
    /* border-right: 1px solid rgba(237, 239, 241, 1); */
    box-sizing: border-box;
    /* position: relative; */

    word-wrap: break-word;
    /* 텍스트를 강제로 줄바꿈 */
    word-break: break-word;
    /* 긴 단어도 줄바꿈 */
    white-space: normal;
    /* 기본 줄바꿈 허용 */
    overflow: hidden;
}

.table-body-tr .td:first-child {
    border-left: none;
    /* border-left: 1px solid rgba(237, 239, 241, 1); */
}

.table-body-tr.dark .td {
    border-right: 1px solid #3f3e3e;
}

.table-body-tr.dark .td:first-child {
    border-left: 1px solid #3f3e3e;
}

.right {
    justify-content: right !important;
    text-align: right !important;
    padding-right: 12px !important;
    padding-left: 8px !important;
    box-sizing: border-box;
}

.left {
    justify-content: left !important;
    text-align: left !important;
    padding-right: 8px !important;
    padding-left: 12px !important;
    box-sizing: border-box;
}


.overflow-hidden {
    overflow: hidden;
    text-overflow: ellipsis;
    display: block !important;
    line-height: 45px;
    cursor: pointer;
}

.overflow-box {
    position: absolute;
    top: 10px;
    /* right: 20%; */
    /* left: 50%;
    transform: translateX(-50%); */
    border: 1px solid #cfcdcd;
    background-color: #f3f3f3;
    border-radius: 3px;
    padding: 5px 15px;
    z-index: 1;
    white-space: wrap;
    word-wrap: break-word;
    overflow: visible !important;
    max-width: 70vw;
    height: 30px;
    line-height: 30px;
}

.overflow-box.dark {
    background-color: #2a2c37;
    border: 1px solid #cccccc16;
}

.table-body-tr div input {
    font-size: 14px;
    width: 80%;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    text-align: center;
    background-color: inherit;
    color: inherit;
    border: 1px solid #e9e9e9;
    border-radius: 5px;
}

.table-body-tr-dash {
    width: 100%;
    height: 35px;
    border-bottom: 1px solid rgba(237, 239, 241, 1);
    display: flex;
    align-items: center;
    justify-content: center;
}

.table-body-tr-dash.dark {
    border-bottom: 1px solid #3f3e3e;
    color: #bdbdbd;
}

.table-body-tr-dash div {
    font-size: 13px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid rgba(237, 239, 241, 1);
    padding: 0 10px;
}

.table-body-tr-dash div:first-child {
    border-left: 1px solid rgba(237, 239, 241, 1);
}

.table-body-tr-dash.dark div {
    border-right: 1px solid #3f3e3e;
}

.table-body-tr-dash.dark div:first-child {
    border-left: 1px solid #3f3e3e;
}

.onclick {
    cursor: pointer;
}

.onclick:hover {
    color: #003577;
    text-decoration: underline;
}

.member-input {
    margin-left: 5px;
    border: none;
    outline: none;
    background-color: inherit;
    color: inherit;
}

.member-country-input {
    width: 75px;
    padding: 3px 0;
    background: none;
    border: none;
    transition: all .2s ease-in-out;
    outline: none;
    color: inherit;
    appearance: none;
    margin-left: 5px;
    border-right: 1px solid rgb(219, 219, 219);
}

.signup_password_modal {
    width: 50%;
    position: absolute;
    top: 45px;
    right: -1px;
    z-index: 100;
    background: #fff;
    padding: 16px;
    padding-bottom: 11px;
    border-radius: 15px;
    box-shadow: rgb(18 18 18 / 8%) 0px 5px 12px;
    max-width: 275px;
}

.signup_password_modal.dark {
    background: #242424;
    color: #fff;
    border: 1px solid #2f2f2f;
}

.signup_password_condition {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    margin-bottom: 5px;
    width: 100%;
}

.signup_password_condition_check {
    width: 14px;
    height: 14px;
    background-size: 11px;
    padding-right: 10px;
    color: #ccc;
}

.signup_password_condition_check.on {
    color: #003577;
}

.spinner-modal {
    /* position: fixed;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center; */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.error-modal {
    background: rgba(0, 0, 0, .3);
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    display: flex;
    text-align: left;
}

.message-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 350px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    font-size: 17px;
    padding: 25px;
    z-index: 10000;
    box-shadow: 1px 1px 4px 1px #656565;
    background-color: #fff;
    border-radius: 5px;
}

.message-modal-2 {
    padding-bottom: 25px;
}

.message-modal-btn {
    width: 100%;
    border: 1px solid #b1b1b1;
    background-color: #d5d5d5;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 4px;
}

.message-modal-btn:hover {
    background-color: #a3a2a2;
}

.data-nofound {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.data-nofound img {
    width: 80px;
}

.data-nofound p {
    opacity: .5;
    font-size: 14px;
    margin: 0;
}

.budget-box {
    width: 100%;
    height: auto;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.161);
    padding: 20px;
    text-align: left;
    margin-bottom: 50px;
}

.budget-1 {
    display: flex;
    align-items: center;
    gap: 50px;
    margin-bottom: 10px;
    height: 30px;
}

.budget-1-1 {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 30px;
}

.budget-1-2 {
    width: 300px;
    height: 100%;
    border-bottom: 1px solid gray;
    display: flex;
    align-items: center;
    justify-content: center;
}

.budget-1-3 {
    width: 120px;
    text-align: left;
}

.budget-2 {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    height: 28px;
}


/* modal */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 30;
}

.modal-box {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .3);
    display: flex;
    align-items: center;
    justify-content: center;
}


.onclick {
    cursor: pointer;
}

.onclick:hover {
    color: #003577;
    text-decoration: underline;
}


.modal-1 {
    width: 1200px;
    /* height: 380px; */
    background-color: #fff;
    border: 1px solid #d5dae0;
    border-radius: 5px;
    box-shadow: 1px 1px 20px 1px #656565;
    padding: 30px;
}

.modal-1.dark {
    background-color: #242424;
    box-shadow: 1px 1px 20px 1px #757575;
    border: 1px solid #3f3e3e;
}


.modal-btn-box {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 10px;
}

.modal-btn-box-btn {
    width: 140px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #dbdbdb;
    border-radius: 5px;
    cursor: pointer;
}

.modal-btn-box-btn.dark {
    background-color: #494848;
}

.modal-btn-box-btn:hover {
    background-color: #003577;
    color: #fff;
}

.modal-btn {
    width: 140px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #dbdbdb;
    border-radius: 5px;
    cursor: pointer;
}

.modal-btn.on {
    background-color: #003577;
    color: #fff;
}

.modal-btn.dark {
    background-color: #494848;
}

.modal-btn:hover {
    background-color: #003577;
    color: #fff;
}


.modal-1-header {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: left;
    padding-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    position: relative;
}

.password {
    font-size: 13px;
    padding-bottom: 4px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
    height: 25px;
}

.password-1 {
    width: 100%;
    /* height: 40px; */
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    padding: 7px 10px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    margin-bottom: 15px;
    font-size: 12px;
}

.password-1.dark {
    background: #494848;
    color: #fff;
    border: 1px solid #3f3e3e;
}

.password-1:focus-within {
    box-shadow: rgb(245 172 29 / 20%) 0px 0px 24px;
    border: 1px solid rgb(245 172 29 / 25%);
    transition: all .2s ease-in-out;
}

.password-1 input {
    width: 100%;
    height: 20px;
    border: none;
    outline: none;
    font-size: 12px;
    background-color: inherit;
}

.password-1.dark input {
    background: #494848;
    color: #fff;
}

.member:hover {
    background: #f3c9c9;
}

.index_sort-btn__eWsx8 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 6px;
}

.table-sort {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.fill-color,
.sort-color {
    color: #003577;
    fill: #003577;
}

.member-id-select-box {
    position: absolute;
    width: 120px !important;
    height: auto !important;
    top: 30px;
    /* right: -60px; */
    border: 1px solid #d9d9d9;
    background-color: #fff;
    border-radius: 5px;
    z-index: 31;
    padding: 0 !important;
    color: #000;
}

.table-grid {
    display: grid;
    box-sizing: border-box;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
}

.table-grid-1 {
    display: grid;
    box-sizing: border-box;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 20px;
    width: calc(100vw - 250px);
}

.skin-card {
    width: 180px;
    height: 237px;
    max-height: 237px;
    border: 1px solid #454545;
    border-radius: 10px;
    margin: 0 auto;
    padding: 10px;
}

.skin-card-header {
    display: flex;
    align-items: center;
    height: 35px;
    width: 100%;
    border-radius: 10px;
    background-color: #FAE7E7;
    font-size: 13px;
}

.skin-card-header-1 {
    padding: 0 10px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background-color: #FCBABA;
}

.skin-card-header-2 {
    margin: 0 7px;
    width: 100%;
    text-align: left;
}

.skin-card-btn {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #797979;
    background-color: #ADADAD;
    color: #fff;
    border-radius: 7px;
    cursor: pointer;
    font-size: 13px;
}

.skin-card-btn.delete {
    border: 1px solid #c00f0c;
    background-color: #FF8280;
    color: #000;
    cursor: pointer;
}

.skin-card-1 {
    width: 230px;
    max-height: 320px;
    border: 1px solid #454545;
    border-radius: 10px;
    margin: 0 auto;
    padding: 10px;
    font-size: 14px;
}

.skin-card-icon {
    position: absolute;
    top: 10px;
    right: 10px;
}

.skin-card-1-1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}

.skin-card-1-3 {
    background-color: #f1f1f1;
    border-radius: 5px;
    width: 150px;
    padding: 0 10px;
    text-align: right;
    height: 25px;
    line-height: 25px;
}

.skin-card-1-4 {
    border: 1px solid #f1f1f1;
    border-radius: 5px;
    width: 150px;
    padding: 0 10px;
    text-align: right;
    height: 25px;
}

.skin-card-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}


.space-between {
    display: flex;
    align-items: center;
    justify-content: space-between !important;
}

.memeber-desc {
    position: absolute;
    width: 300px !important;
    top: 30px;
    /* left: 0px; */
    border: 1px solid #d9d9d9;
    background-color: #fff;
    border-radius: 5px;
    z-index: 31;
    color: #000;
    padding: 10px;
}

.member-desc-btn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
}

.member-desc-btn-1 {
    background-color: #FC8787;
    border-radius: 5px;
    height: 30px;
    padding: 0 10px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.member-desc-btn-2 {
    background-color: #C1C1C1;
    border-radius: 5px;
    padding: 0 10px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.member-status-select-box {
    position: absolute;
    width: 120px !important;
    height: auto !important;
    top: 33px;
    border: 1px solid #d9d9d9;
    background-color: #fff;
    border-radius: 5px;
    /* animation: member_drowdown .5s ease-in-out; */
    z-index: 31;
    flex-direction: column;
    align-items: flex-start !important;
    padding: 0 !important;
}

.member-status-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    padding: 8px 12px !important;
    font-size: 14px !important;
    border: none !important;
}

.form-control {
    width: 300px;
    overflow-x: auto;
    font-size: 13px;
    text-align: center;
}

.file-input {
    height: 26px;
    border: 1px solid #bbbbbb;
    border-radius: 5px;
    text-align: center;
    font-size: 12px;
}

.create-img-box {
    display: flex;
    gap: 40px;
    font-size: 14px;
}

.ads-preImg {}

.ads-btn {
    width: 140px;
    height: 38px;
    background-color: #e3e3e3;
    border: 1px solid #a1a1a1;
    border-radius: 5px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.table-flex {
    display: flex;
    align-items: center;
    gap: 50px;
}

.gameSetting-btn-1 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 10px;
}

.gameSetting-btn-2 {
    width: 140px;
    height: 38px;
    background-color: #e3e3e3;
    border: 1px solid #a1a1a1;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
}

.gameSetting-btn-3 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.gameSetting-btn-4 {
    width: 140px;
    height: 38px;
    background-color: #ff2929;
    border: 1px solid #a1a1a1;
    color: #fff;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
}

.gameSetting-btn-text {
    font-size: 17px;
    font-weight: bold;
}

.maintab {
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    margin: 0px 0 10px;
    position: relative;
}

.maintab-btn {
    width: auto;
    padding: 5px 20px;
    /* width: 110px; */
    height: 32px;
    background-color: rgba(237, 239, 241, 1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.maintab-1 {
    width: auto;
    padding: 5px 20px;
    /* width: 110px; */
    height: 32px;
    background-color: rgba(237, 239, 241, 1);
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
}

.maintab-1.dark {
    background: #494848;
    color: #fff;
}

.maintab-btn.on,
.maintab-1.on {
    background-color: #003577;
    color: #fff;
}

.maintab-1-2 {
    width: 130px;
    height: 32px;
    background-color: rgba(237, 239, 241, 1);
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    font-size: 14px;
}

.maintab-2 {
    width: 130px;
    height: 32px;
    background-color: rgba(237, 239, 241, 1);
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    font-size: 14px;
}

.maintab-2.dark {
    background-color: #494848;
    color: #fff;
}

.maintab-1-2:hover,
.maintab-2:hover {
    background-color: #003577;
    color: #fff;
}

.apexcharts-legend-series {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 20px;
}

.main-upgrade-guide {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 20px;
}

.main-upgrade-guide-input {
    width: 600px;
    border: 1px solid #d3d3d3;
    padding: 10px;
    outline: none;
    border-radius: 5px;
    font-size: 14px;
    text-align: left
}


.upgrade-btn {
    background-color: #e5e5e5;
    border: 1px solid #d5d5d5;
    border-radius: 5px;
    padding: 0 10px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.main-box {
    padding-bottom: 50px;
}

.main-box-1 {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 50px;
    padding-bottom: 50px;
}

.modal-flex {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 30px;
    margin-bottom: 30px;
}

.modal-body {
    margin-bottom: 30px;
}


.modal-body-flex {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 10px;
    text-align: left;
}

.table-overflow-hidden {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block !important;
}

select {
    background-color: transparent;
}

.react-datepicker__input-container input {
    width: 150px;
    border: none;
    outline: none;
    background: inherit;
    cursor: pointer;
    text-align: center;
    color: rgba(136, 136, 136, 1);
    padding: 13px 12px 10px;
    font-size: 14px;
}

.modal-3-1-left.dark .react-datepicker__input-container input {
    color: #fff;
}

.modal-3-1-left-1.on .react-datepicker__input-container input {
    color: #fff;
}

.modal-3-1-left-1:hover .react-datepicker__input-container input {
    color: #fff;
}

.modal-3-1-left {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    height: 35px;
}

.modal-3-1-left-1 {
    padding: 6px 12px;
    background-color: rgba(237, 239, 241, 1);
    color: rgba(136, 136, 136, 1);
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-3-1-left.dark .modal-3-1-left-1 {
    background: #494848;
    color: #fff;
}

.modal-3-1-left .modal-3-1-left-1.on {
    background-color: #003577;
    color: #fff;
}

.modal-3-1-left .modal-3-1-left-1:hover {
    background-color: #003577;
    color: #fff;
}

.excel {
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    margin: 30px 0 10px;
    position: relative;
}

.excel-btn {
    width: 130px;
    height: 32px;
    background-color: rgba(237, 239, 241, 1);
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
}

.excel-btn:hover {
    background-color: #003577;
    color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/Pages/css/main.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,kEAAkE;IAClE,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,WAAW;IACX,0CAA0C;AAC9C;;AAEA;IACI;QACI,UAAU;QACV,iCAAiC;IACrC;;IAEA;QACI,UAAU;QACV,+BAA+B;IACnC;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,6BAA6B;AACjC;;AAEA,WAAW;AACX;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;IACnB,WAAW;AACf;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;;IAEI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;IACT,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,gDAAgD;IAChD,WAAW;IACX,sBAAsB;IACtB,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,gDAAgD;IAChD,WAAW;IACX,sBAAsB;IACtB,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,uBAAuB;IACvB,SAAS;IACT,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,gDAAgD;IAChD,WAAW;IACX,sBAAsB;IACtB,kCAAkC;IAClC,qBAAqB;IACrB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;;;;;IAKI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;;;;;IAMI,gBAAgB;IAChB,4BAA4B;IAC5B,0BAA0B;IAC1B,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;;;;;;IAMI,yBAAyB;AAC7B;;AAEA;;;;;IAKI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,OAAO;IACP,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,gDAAgD;IAChD,WAAW;IACX,sBAAsB;IACtB,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,OAAO;IACP,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,gDAAgD;IAChD,WAAW;IACX,sBAAsB;IACtB,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI;QACI,YAAY;QACZ,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,gCAAgC;IAChC,qDAAqD;AACzD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,qDAAqD;AACzD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,oBAAoB;IACpB,eAAe;AACnB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+CAA+C;IAC/C,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,6CAA6C;IAC7C,oDAAoD;IACpD,sBAAsB;IACtB,wBAAwB;;IAExB,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mDAAmD;AACvD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;IACjC,4BAA4B;IAC5B,8BAA8B;IAC9B,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,6BAA6B;IAC7B,6BAA6B;IAC7B,sBAAsB;AAC1B;;;AAGA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB;kCAC8B;IAC9B,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,iBAAiB;IACjB,qBAAqB;IACrB,4BAA4B;IAC5B,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+CAA+C;IAC/C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8CAA8C;IAC9C,eAAe;AACnB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,cAAc;IAGd,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;;;;;8BAK0B;IAC1B,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,cAAc;IACd,mCAAmC;IACnC,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,gDAAgD;IAChD,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,YAAY;AAChB;;;AAGA,UAAU;AACV;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,yBAAyB;AAC7B;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;;AAGA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,8CAA8C;IAC9C,uCAAuC;IACvC,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;IAEI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,2DAA2D;IAC3D,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;IACT,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,gDAAgD;IAChD,WAAW;IACX,sBAAsB;IACtB,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,4BAA4B;IAC5B,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA,aAAa;;AAEb;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;;IAEI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;;IAEI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf;AACJ;;;AAGA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,wCAAwC;IACxC,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf","sourcesContent":[".buy-modal {\r\n    position: fixed;\r\n    top: 20px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    width: auto;\r\n    min-width: 300px;\r\n    max-width: 700px;\r\n    /* height: 60px; */\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 10px;\r\n    font-size: 15px;\r\n    padding: 15px 20px;\r\n    z-index: 100;\r\n}\r\n\r\n.buy-modal.dark {\r\n    color: #121212;\r\n}\r\n\r\n.buy-modal.copy {\r\n    border: 1px solid rgba(0, 9, 3, .08);\r\n    background-color: #fff;\r\n    box-shadow: 0 20px 25px -5px #0000001a, 0 10px 10px -5px #0000000a;\r\n    animation: Modal_opacityIn .4s ease-in-out;\r\n}\r\n\r\n.buy-modal.copy.dark {\r\n    border: 1px solid #cccccc16;\r\n    background-color: #2b2c37;\r\n    color: #fff;\r\n    animation: Modal_opacityIn .4s ease-in-out;\r\n}\r\n\r\n@keyframes Modal_opacityIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: translate(-50%, -20px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translate(-50%, 0px);\r\n    }\r\n}\r\n\r\n.input-box {\r\n    padding: 12px 15px !important;\r\n}\r\n\r\n.input-btn {\r\n    padding: 5px 10px;\r\n    background: rgba(239, 239, 239, 1);\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-size: 13px;\r\n}\r\n\r\n.main {\r\n    width: 100vw;\r\n    min-width: 1920px;\r\n    height: 100vh;\r\n    padding: 85px 20px 55px 220px;\r\n}\r\n\r\n/* member */\r\n.member-1 {\r\n    /* width: 100%; */\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 5px;\r\n}\r\n\r\n.member-1-search {\r\n    width: 235px;\r\n    height: 32px;\r\n    border: 1px solid #dbdbdb;\r\n    border-radius: 5px;\r\n    background-color: #fff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: relative;\r\n}\r\n\r\n.member-1-search.dark {\r\n    background: #494848;\r\n    color: #fff;\r\n    border: 1px solid #3f3e3e;\r\n}\r\n\r\n.member-1-search input {\r\n    width: 170px;\r\n    height: 30px;\r\n    background-color: #fff;\r\n    border: none;\r\n    outline: none;\r\n}\r\n\r\n.member-1-search.dark input {\r\n    background: #494848;\r\n    color: #fff;\r\n}\r\n\r\n.member-1-search-ico-1 {\r\n    font-size: 15px;\r\n    position: absolute;\r\n    left: 10px;\r\n}\r\n\r\n.member-1-search-ico-2 {\r\n    font-size: 15px;\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    right: 10px;\r\n    color: #a1a0a0;\r\n    cursor: pointer;\r\n}\r\n\r\n.search-btn {\r\n    padding: 0px 10px;\r\n    height: 35px;\r\n    font-size: 13px;\r\n    border: 1px solid #dbdbdb;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    background-color: #fff;\r\n}\r\n\r\n.search-btn.dark {\r\n    background: #494848;\r\n    border: 1px solid #494848;\r\n    color: #fff;\r\n}\r\n\r\n.search-btn:hover {\r\n    background-color: #003577;\r\n    color: #fff;\r\n}\r\n\r\n.member-1-select {\r\n    width: 160px !important;\r\n    height: 30px !important;\r\n    border-radius: 5px;\r\n    background-color: #fff;\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n    flex-direction: column;\r\n    position: relative;\r\n    cursor: pointer;\r\n}\r\n\r\n.member-2-select {\r\n    width: 100px !important;\r\n    height: 25px !important;\r\n    border-radius: 5px;\r\n    background-color: #fff;\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n    flex-direction: column;\r\n    position: relative;\r\n    cursor: pointer;\r\n}\r\n\r\n.member-1-select.dark,\r\n.member-2-select.dark {\r\n    background: #494848;\r\n    color: #fff;\r\n}\r\n\r\n.member-1-select.border,\r\n.member-2-select.border {\r\n    border: 1px solid #e9e9e9;\r\n}\r\n\r\n.member-1-select.border.dark,\r\n.member-1-select.border.dark {\r\n    border: 1px solid #3f3e3e;\r\n}\r\n\r\n.member-1-select-1 {\r\n    width: calc(100% - 15px) !important;\r\n    text-align: left;\r\n    padding-left: 5px;\r\n    font-size: 14px;\r\n    justify-content: flex-start !important;\r\n    border: none !important;\r\n}\r\n\r\n.member-1-select svg,\r\n.member-2-select svg {\r\n    font-size: 18px;\r\n    position: absolute;\r\n    right: 15px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    color: #8b8b8b;\r\n}\r\n\r\n.member-1-select-box {\r\n    position: absolute;\r\n    width: 150px !important;\r\n    height: auto !important;\r\n    top: 33px;\r\n    border: 1px solid #d9d9d9;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n    /* animation: member_drowdown .5s ease-in-out; */\r\n    z-index: 31;\r\n    flex-direction: column;\r\n    align-items: flex-start !important;\r\n    padding: 0 !important;\r\n}\r\n\r\n.member-2-select-box {\r\n    position: absolute;\r\n    width: 90px !important;\r\n    height: auto !important;\r\n    top: 33px;\r\n    border: 1px solid #d9d9d9;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n    /* animation: member_drowdown .5s ease-in-out; */\r\n    z-index: 31;\r\n    flex-direction: column;\r\n    align-items: flex-start !important;\r\n    padding: 0 !important;\r\n}\r\n\r\n.member-3-select-box {\r\n    position: absolute;\r\n    width: calc(100% - 15px) !important;\r\n    height: auto !important;\r\n    top: 44px;\r\n    border: 1px solid #d9d9d9;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n    /* animation: member_drowdown .5s ease-in-out; */\r\n    z-index: 31;\r\n    flex-direction: column;\r\n    align-items: flex-start !important;\r\n    padding: 0 !important;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n}\r\n\r\n.member-1-select-box.dark,\r\n.member-2-select-box.dark,\r\n.member-3-select-box.dark,\r\n.dashboard-1-select-box.dark,\r\n.dashboard-2-select-box.dark {\r\n    background: #494848;\r\n    color: #fff;\r\n    border: 1px solid #2f2f2f;\r\n}\r\n\r\n.member-1-select-box div,\r\n.member-id-select-box div,\r\n.member-2-select-box div,\r\n.member-3-select-box div,\r\n.dashboard-1-select-box div,\r\n.dashboard-2-select-box div {\r\n    text-align: left;\r\n    padding: 8px 12px !important;\r\n    font-size: 14px !important;\r\n    justify-content: flex-start !important;\r\n    border: none !important;\r\n}\r\n\r\n.member-1-select-box div:hover,\r\n.member-id-select-box div:hover,\r\n.member-2-select-box div:hover,\r\n.member-3-select-box div:hover,\r\n.dashboard-1-select-box div:hover,\r\n.dashboard-2-select-box div:hover {\r\n    background-color: #e9e9e9;\r\n}\r\n\r\n.member-1-select-box.dark div:hover,\r\n.member-2-select-box.dark div:hover,\r\n.member-3-select-box.dark div:hover,\r\n.dashboard-1-select-box.dark div:hover,\r\n.dashboard-2-select-box.dark div:hover {\r\n    background-color: #5e5e5e;\r\n}\r\n\r\n.dashboard-1-select-box {\r\n    position: absolute;\r\n    width: 93px !important;\r\n    height: auto !important;\r\n    top: 33px;\r\n    left: 0;\r\n    border: 1px solid #d9d9d9;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n    /* animation: member_drowdown .5s ease-in-out; */\r\n    z-index: 31;\r\n    flex-direction: column;\r\n    align-items: flex-start !important;\r\n    color: #121212;\r\n}\r\n\r\n.dashboard-2-select-box {\r\n    position: absolute;\r\n    width: 72px !important;\r\n    height: auto !important;\r\n    top: 33px;\r\n    left: 0;\r\n    border: 1px solid #d9d9d9;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n    /* animation: member_drowdown .5s ease-in-out; */\r\n    z-index: 31;\r\n    flex-direction: column;\r\n    align-items: flex-start !important;\r\n    color: #121212;\r\n}\r\n\r\n@keyframes member_drowdown {\r\n    from {\r\n        opacity: 0.9;\r\n        transform: translateY(-10px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n.member-2-search {\r\n    width: 380px;\r\n    height: 35px;\r\n    border: 1px solid #dbdbdb;\r\n    border-radius: 5px;\r\n    background-color: #fff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: relative;\r\n}\r\n\r\n.member-2-search.dark {\r\n    background: #494848;\r\n    color: #fff;\r\n    border: 1px solid #2f2f2f;\r\n}\r\n\r\n.member-2-search-1 {\r\n    width: 200px;\r\n    height: 30px;\r\n    /* border: 1px solid #003577; */\r\n    border-radius: 5px;\r\n    background-color: #fff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    padding-left: 15px;\r\n    position: relative;\r\n}\r\n\r\n.member-2-search-1.dark {\r\n    background: #494848;\r\n    color: #fff;\r\n}\r\n\r\n.member-2-search-1 input {\r\n    width: 170px;\r\n    height: 30px;\r\n    background-color: #fff;\r\n    border: none;\r\n    outline: none;\r\n}\r\n\r\n.member-2-search-1.dark input {\r\n    background: #494848;\r\n    color: #fff;\r\n}\r\n\r\n.member-1-search-ico-3 {\r\n    font-size: 15px;\r\n    position: absolute;\r\n    left: -5px;\r\n}\r\n\r\n.line {\r\n    transform: rotate(90deg);\r\n    font-size: 22px;\r\n    color: #dbdbdb;\r\n}\r\n\r\n.member-2 {\r\n    width: 100%;\r\n    height: auto;\r\n    margin-top: 15px;\r\n    padding-bottom: 30px;\r\n}\r\n\r\n.member-2.dark {\r\n    color: #dddbdb;\r\n}\r\n\r\n.table-head {\r\n    padding-top: 10px;\r\n    width: 100%;\r\n    height: 47px;\r\n    display: flex;\r\n    align-items: center;\r\n    /* justify-content: center; */\r\n    border-bottom: 2px solid #000000;\r\n    /* border-bottom: 2px solid rgba(237, 239, 241, 1); */\r\n}\r\n\r\n.table-head svg {\r\n    cursor: pointer;\r\n}\r\n\r\n.table-head.dark {\r\n    border-bottom: 2px solid #3f3e3e;\r\n}\r\n\r\n.table-head div {\r\n    font-size: 13px;\r\n    font-weight: bold;\r\n    width: 100%;\r\n    /* color: #636363; */\r\n    position: relative;\r\n    padding: 0 8px;\r\n}\r\n\r\n.table-head-dash {\r\n    /* padding-top: 10px; */\r\n    width: 100%;\r\n    height: 35px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-bottom: 2px solid #000000;\r\n    /* border-bottom: 2px solid rgba(237, 239, 241, 1); */\r\n}\r\n\r\n.table-head-dash.dark {\r\n    border-bottom: 2px solid #3f3e3e;\r\n}\r\n\r\n.table-head-dash div {\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    width: 100%;\r\n    /* color: #636363; */\r\n    padding: 0 10px;\r\n}\r\n\r\n\r\n.table-body {\r\n    width: 100%;\r\n    height: auto;\r\n    position: relative;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.table-body-tr {\r\n    width: 100%;\r\n    height: 40px;\r\n    border-bottom: 1px solid rgba(237, 239, 241, 1);\r\n    display: flex;\r\n    align-items: center;\r\n    /* justify-content: center; */\r\n    position: relative;\r\n}\r\n\r\n.table-body-tr.dark {\r\n    border-bottom: 1px solid #3f3e3e;\r\n    color: #bdbdbd;\r\n}\r\n\r\n.table-body-tr-1 {\r\n    width: 30%;\r\n    height: 30px;\r\n    border-right: 1px solid rgba(237, 239, 241, 1);\r\n}\r\n\r\n.table-body-tr-1.dark {\r\n    border-right: 1px solid #3f3e3e;\r\n}\r\n\r\n.table-body-tr .td {\r\n    font-size: 12px;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 0 10px;\r\n    border-left: 1px solid rgba(237, 239, 241, 1);\r\n    /* border-right: 1px solid rgba(237, 239, 241, 1); */\r\n    box-sizing: border-box;\r\n    /* position: relative; */\r\n\r\n    word-wrap: break-word;\r\n    /* 텍스트를 강제로 줄바꿈 */\r\n    word-break: break-word;\r\n    /* 긴 단어도 줄바꿈 */\r\n    white-space: normal;\r\n    /* 기본 줄바꿈 허용 */\r\n    overflow: hidden;\r\n}\r\n\r\n.table-body-tr .td:first-child {\r\n    border-left: none;\r\n    /* border-left: 1px solid rgba(237, 239, 241, 1); */\r\n}\r\n\r\n.table-body-tr.dark .td {\r\n    border-right: 1px solid #3f3e3e;\r\n}\r\n\r\n.table-body-tr.dark .td:first-child {\r\n    border-left: 1px solid #3f3e3e;\r\n}\r\n\r\n.right {\r\n    justify-content: right !important;\r\n    text-align: right !important;\r\n    padding-right: 12px !important;\r\n    padding-left: 8px !important;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.left {\r\n    justify-content: left !important;\r\n    text-align: left !important;\r\n    padding-right: 8px !important;\r\n    padding-left: 12px !important;\r\n    box-sizing: border-box;\r\n}\r\n\r\n\r\n.overflow-hidden {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: block !important;\r\n    line-height: 45px;\r\n    cursor: pointer;\r\n}\r\n\r\n.overflow-box {\r\n    position: absolute;\r\n    top: 10px;\r\n    /* right: 20%; */\r\n    /* left: 50%;\r\n    transform: translateX(-50%); */\r\n    border: 1px solid #cfcdcd;\r\n    background-color: #f3f3f3;\r\n    border-radius: 3px;\r\n    padding: 5px 15px;\r\n    z-index: 1;\r\n    white-space: wrap;\r\n    word-wrap: break-word;\r\n    overflow: visible !important;\r\n    max-width: 70vw;\r\n    height: 30px;\r\n    line-height: 30px;\r\n}\r\n\r\n.overflow-box.dark {\r\n    background-color: #2a2c37;\r\n    border: 1px solid #cccccc16;\r\n}\r\n\r\n.table-body-tr div input {\r\n    font-size: 14px;\r\n    width: 80%;\r\n    height: 25px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    outline: none;\r\n    text-align: center;\r\n    background-color: inherit;\r\n    color: inherit;\r\n    border: 1px solid #e9e9e9;\r\n    border-radius: 5px;\r\n}\r\n\r\n.table-body-tr-dash {\r\n    width: 100%;\r\n    height: 35px;\r\n    border-bottom: 1px solid rgba(237, 239, 241, 1);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.table-body-tr-dash.dark {\r\n    border-bottom: 1px solid #3f3e3e;\r\n    color: #bdbdbd;\r\n}\r\n\r\n.table-body-tr-dash div {\r\n    font-size: 13px;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-right: 1px solid rgba(237, 239, 241, 1);\r\n    padding: 0 10px;\r\n}\r\n\r\n.table-body-tr-dash div:first-child {\r\n    border-left: 1px solid rgba(237, 239, 241, 1);\r\n}\r\n\r\n.table-body-tr-dash.dark div {\r\n    border-right: 1px solid #3f3e3e;\r\n}\r\n\r\n.table-body-tr-dash.dark div:first-child {\r\n    border-left: 1px solid #3f3e3e;\r\n}\r\n\r\n.onclick {\r\n    cursor: pointer;\r\n}\r\n\r\n.onclick:hover {\r\n    color: #003577;\r\n    text-decoration: underline;\r\n}\r\n\r\n.member-input {\r\n    margin-left: 5px;\r\n    border: none;\r\n    outline: none;\r\n    background-color: inherit;\r\n    color: inherit;\r\n}\r\n\r\n.member-country-input {\r\n    width: 75px;\r\n    padding: 3px 0;\r\n    background: none;\r\n    border: none;\r\n    transition: all .2s ease-in-out;\r\n    outline: none;\r\n    color: inherit;\r\n    -moz-appearance: none;\r\n    -webkit-appearance: none;\r\n    appearance: none;\r\n    margin-left: 5px;\r\n    border-right: 1px solid rgb(219, 219, 219);\r\n}\r\n\r\n.signup_password_modal {\r\n    width: 50%;\r\n    position: absolute;\r\n    top: 45px;\r\n    right: -1px;\r\n    z-index: 100;\r\n    background: #fff;\r\n    padding: 16px;\r\n    padding-bottom: 11px;\r\n    border-radius: 15px;\r\n    box-shadow: rgb(18 18 18 / 8%) 0px 5px 12px;\r\n    max-width: 275px;\r\n}\r\n\r\n.signup_password_modal.dark {\r\n    background: #242424;\r\n    color: #fff;\r\n    border: 1px solid #2f2f2f;\r\n}\r\n\r\n.signup_password_condition {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    font-size: 12px;\r\n    margin-bottom: 5px;\r\n    width: 100%;\r\n}\r\n\r\n.signup_password_condition_check {\r\n    width: 14px;\r\n    height: 14px;\r\n    background-size: 11px;\r\n    padding-right: 10px;\r\n    color: #ccc;\r\n}\r\n\r\n.signup_password_condition_check.on {\r\n    color: #003577;\r\n}\r\n\r\n.spinner-modal {\r\n    /* position: fixed;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center; */\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n}\r\n\r\n.error-modal {\r\n    background: rgba(0, 0, 0, .3);\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    z-index: 9999;\r\n    display: flex;\r\n    text-align: left;\r\n}\r\n\r\n.message-modal {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    width: 100%;\r\n    max-width: 350px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    flex-direction: column;\r\n    font-size: 17px;\r\n    padding: 25px;\r\n    z-index: 10000;\r\n    box-shadow: 1px 1px 4px 1px #656565;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n}\r\n\r\n.message-modal-2 {\r\n    padding-bottom: 25px;\r\n}\r\n\r\n.message-modal-btn {\r\n    width: 100%;\r\n    border: 1px solid #b1b1b1;\r\n    background-color: #d5d5d5;\r\n    height: 35px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n}\r\n\r\n.message-modal-btn:hover {\r\n    background-color: #a3a2a2;\r\n}\r\n\r\n.data-nofound {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n}\r\n\r\n.data-nofound img {\r\n    width: 80px;\r\n}\r\n\r\n.data-nofound p {\r\n    opacity: .5;\r\n    font-size: 14px;\r\n    margin: 0;\r\n}\r\n\r\n.budget-box {\r\n    width: 100%;\r\n    height: auto;\r\n    border-radius: 5px;\r\n    background-color: #fff;\r\n    box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.161);\r\n    padding: 20px;\r\n    text-align: left;\r\n    margin-bottom: 50px;\r\n}\r\n\r\n.budget-1 {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 50px;\r\n    margin-bottom: 10px;\r\n    height: 30px;\r\n}\r\n\r\n.budget-1-1 {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    height: 30px;\r\n}\r\n\r\n.budget-1-2 {\r\n    width: 300px;\r\n    height: 100%;\r\n    border-bottom: 1px solid gray;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.budget-1-3 {\r\n    width: 120px;\r\n    text-align: left;\r\n}\r\n\r\n.budget-2 {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    margin-bottom: 10px;\r\n    height: 28px;\r\n}\r\n\r\n\r\n/* modal */\r\n.modal {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    z-index: 30;\r\n}\r\n\r\n.modal-box {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, .3);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n\r\n.onclick {\r\n    cursor: pointer;\r\n}\r\n\r\n.onclick:hover {\r\n    color: #003577;\r\n    text-decoration: underline;\r\n}\r\n\r\n\r\n.modal-1 {\r\n    width: 1200px;\r\n    /* height: 380px; */\r\n    background-color: #fff;\r\n    border: 1px solid #d5dae0;\r\n    border-radius: 5px;\r\n    box-shadow: 1px 1px 20px 1px #656565;\r\n    padding: 30px;\r\n}\r\n\r\n.modal-1.dark {\r\n    background-color: #242424;\r\n    box-shadow: 1px 1px 20px 1px #757575;\r\n    border: 1px solid #3f3e3e;\r\n}\r\n\r\n\r\n.modal-btn-box {\r\n    width: 100%;\r\n    height: 40px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: end;\r\n    gap: 10px;\r\n}\r\n\r\n.modal-btn-box-btn {\r\n    width: 140px;\r\n    height: 40px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: #dbdbdb;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n}\r\n\r\n.modal-btn-box-btn.dark {\r\n    background-color: #494848;\r\n}\r\n\r\n.modal-btn-box-btn:hover {\r\n    background-color: #003577;\r\n    color: #fff;\r\n}\r\n\r\n.modal-btn {\r\n    width: 140px;\r\n    height: 40px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: #dbdbdb;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n}\r\n\r\n.modal-btn.on {\r\n    background-color: #003577;\r\n    color: #fff;\r\n}\r\n\r\n.modal-btn.dark {\r\n    background-color: #494848;\r\n}\r\n\r\n.modal-btn:hover {\r\n    background-color: #003577;\r\n    color: #fff;\r\n}\r\n\r\n\r\n.modal-1-header {\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n    margin-bottom: 20px;\r\n    text-align: left;\r\n    padding-bottom: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 10px;\r\n    position: relative;\r\n}\r\n\r\n.password {\r\n    font-size: 13px;\r\n    padding-bottom: 4px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 5px;\r\n    height: 25px;\r\n}\r\n\r\n.password-1 {\r\n    width: 100%;\r\n    /* height: 40px; */\r\n    border: 1px solid #e7e7e7;\r\n    border-radius: 5px;\r\n    padding: 7px 10px;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    position: relative;\r\n    margin-bottom: 15px;\r\n    font-size: 12px;\r\n}\r\n\r\n.password-1.dark {\r\n    background: #494848;\r\n    color: #fff;\r\n    border: 1px solid #3f3e3e;\r\n}\r\n\r\n.password-1:focus-within {\r\n    box-shadow: rgb(245 172 29 / 20%) 0px 0px 24px;\r\n    border: 1px solid rgb(245 172 29 / 25%);\r\n    transition: all .2s ease-in-out;\r\n}\r\n\r\n.password-1 input {\r\n    width: 100%;\r\n    height: 20px;\r\n    border: none;\r\n    outline: none;\r\n    font-size: 12px;\r\n    background-color: inherit;\r\n}\r\n\r\n.password-1.dark input {\r\n    background: #494848;\r\n    color: #fff;\r\n}\r\n\r\n.member:hover {\r\n    background: #f3c9c9;\r\n}\r\n\r\n.index_sort-btn__eWsx8 {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    margin-left: 6px;\r\n}\r\n\r\n.table-sort {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.fill-color,\r\n.sort-color {\r\n    color: #003577;\r\n    fill: #003577;\r\n}\r\n\r\n.member-id-select-box {\r\n    position: absolute;\r\n    width: 120px !important;\r\n    height: auto !important;\r\n    top: 30px;\r\n    /* right: -60px; */\r\n    border: 1px solid #d9d9d9;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n    z-index: 31;\r\n    padding: 0 !important;\r\n    color: #000;\r\n}\r\n\r\n.table-grid {\r\n    display: grid;\r\n    box-sizing: border-box;\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n    gap: 20px;\r\n}\r\n\r\n.table-grid-1 {\r\n    display: grid;\r\n    box-sizing: border-box;\r\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\r\n    gap: 20px;\r\n    width: calc(100vw - 250px);\r\n}\r\n\r\n.skin-card {\r\n    width: 180px;\r\n    height: 237px;\r\n    max-height: 237px;\r\n    border: 1px solid #454545;\r\n    border-radius: 10px;\r\n    margin: 0 auto;\r\n    padding: 10px;\r\n}\r\n\r\n.skin-card-header {\r\n    display: flex;\r\n    align-items: center;\r\n    height: 35px;\r\n    width: 100%;\r\n    border-radius: 10px;\r\n    background-color: #FAE7E7;\r\n    font-size: 13px;\r\n}\r\n\r\n.skin-card-header-1 {\r\n    padding: 0 10px;\r\n    height: 35px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 10px;\r\n    background-color: #FCBABA;\r\n}\r\n\r\n.skin-card-header-2 {\r\n    margin: 0 7px;\r\n    width: 100%;\r\n    text-align: left;\r\n}\r\n\r\n.skin-card-btn {\r\n    width: 100%;\r\n    height: 30px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border: 1px solid #797979;\r\n    background-color: #ADADAD;\r\n    color: #fff;\r\n    border-radius: 7px;\r\n    cursor: pointer;\r\n    font-size: 13px;\r\n}\r\n\r\n.skin-card-btn.delete {\r\n    border: 1px solid #c00f0c;\r\n    background-color: #FF8280;\r\n    color: #000;\r\n    cursor: pointer;\r\n}\r\n\r\n.skin-card-1 {\r\n    width: 230px;\r\n    max-height: 320px;\r\n    border: 1px solid #454545;\r\n    border-radius: 10px;\r\n    margin: 0 auto;\r\n    padding: 10px;\r\n    font-size: 14px;\r\n}\r\n\r\n.skin-card-icon {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n}\r\n\r\n.skin-card-1-1 {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.skin-card-1-3 {\r\n    background-color: #f1f1f1;\r\n    border-radius: 5px;\r\n    width: 150px;\r\n    padding: 0 10px;\r\n    text-align: right;\r\n    height: 25px;\r\n    line-height: 25px;\r\n}\r\n\r\n.skin-card-1-4 {\r\n    border: 1px solid #f1f1f1;\r\n    border-radius: 5px;\r\n    width: 150px;\r\n    padding: 0 10px;\r\n    text-align: right;\r\n    height: 25px;\r\n}\r\n\r\n.skin-card-buttons {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 10px;\r\n}\r\n\r\n\r\n.space-between {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between !important;\r\n}\r\n\r\n.memeber-desc {\r\n    position: absolute;\r\n    width: 300px !important;\r\n    top: 30px;\r\n    /* left: 0px; */\r\n    border: 1px solid #d9d9d9;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n    z-index: 31;\r\n    color: #000;\r\n    padding: 10px;\r\n}\r\n\r\n.member-desc-btn {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    gap: 10px;\r\n}\r\n\r\n.member-desc-btn-1 {\r\n    background-color: #FC8787;\r\n    border-radius: 5px;\r\n    height: 30px;\r\n    padding: 0 10px;\r\n    color: #fff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.member-desc-btn-2 {\r\n    background-color: #C1C1C1;\r\n    border-radius: 5px;\r\n    padding: 0 10px;\r\n    height: 30px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.member-status-select-box {\r\n    position: absolute;\r\n    width: 120px !important;\r\n    height: auto !important;\r\n    top: 33px;\r\n    border: 1px solid #d9d9d9;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n    /* animation: member_drowdown .5s ease-in-out; */\r\n    z-index: 31;\r\n    flex-direction: column;\r\n    align-items: flex-start !important;\r\n    padding: 0 !important;\r\n}\r\n\r\n.member-status-box {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    text-align: left;\r\n    padding: 8px 12px !important;\r\n    font-size: 14px !important;\r\n    border: none !important;\r\n}\r\n\r\n.form-control {\r\n    width: 300px;\r\n    overflow-x: auto;\r\n    font-size: 13px;\r\n    text-align: center;\r\n}\r\n\r\n.file-input {\r\n    height: 26px;\r\n    border: 1px solid #bbbbbb;\r\n    border-radius: 5px;\r\n    text-align: center;\r\n    font-size: 12px;\r\n}\r\n\r\n.create-img-box {\r\n    display: flex;\r\n    gap: 40px;\r\n    font-size: 14px;\r\n}\r\n\r\n.ads-preImg {}\r\n\r\n.ads-btn {\r\n    width: 140px;\r\n    height: 38px;\r\n    background-color: #e3e3e3;\r\n    border: 1px solid #a1a1a1;\r\n    border-radius: 5px;\r\n    margin-top: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.table-flex {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 50px;\r\n}\r\n\r\n.gameSetting-btn-1 {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: end;\r\n    gap: 10px;\r\n}\r\n\r\n.gameSetting-btn-2 {\r\n    width: 140px;\r\n    height: 38px;\r\n    background-color: #e3e3e3;\r\n    border: 1px solid #a1a1a1;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n}\r\n\r\n.gameSetting-btn-3 {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.gameSetting-btn-4 {\r\n    width: 140px;\r\n    height: 38px;\r\n    background-color: #ff2929;\r\n    border: 1px solid #a1a1a1;\r\n    color: #fff;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n}\r\n\r\n.gameSetting-btn-text {\r\n    font-size: 17px;\r\n    font-weight: bold;\r\n}\r\n\r\n.maintab {\r\n    width: 100%;\r\n    height: 32px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 10px;\r\n    margin: 0px 0 10px;\r\n    position: relative;\r\n}\r\n\r\n.maintab-btn {\r\n    width: auto;\r\n    padding: 5px 20px;\r\n    /* width: 110px; */\r\n    height: 32px;\r\n    background-color: rgba(237, 239, 241, 1);\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.maintab-1 {\r\n    width: auto;\r\n    padding: 5px 20px;\r\n    /* width: 110px; */\r\n    height: 32px;\r\n    background-color: rgba(237, 239, 241, 1);\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n}\r\n\r\n.maintab-1.dark {\r\n    background: #494848;\r\n    color: #fff;\r\n}\r\n\r\n.maintab-btn.on,\r\n.maintab-1.on {\r\n    background-color: #003577;\r\n    color: #fff;\r\n}\r\n\r\n.maintab-1-2 {\r\n    width: 130px;\r\n    height: 32px;\r\n    background-color: rgba(237, 239, 241, 1);\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: absolute;\r\n    right: 0;\r\n    font-size: 14px;\r\n}\r\n\r\n.maintab-2 {\r\n    width: 130px;\r\n    height: 32px;\r\n    background-color: rgba(237, 239, 241, 1);\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: absolute;\r\n    right: 0;\r\n    font-size: 14px;\r\n}\r\n\r\n.maintab-2.dark {\r\n    background-color: #494848;\r\n    color: #fff;\r\n}\r\n\r\n.maintab-1-2:hover,\r\n.maintab-2:hover {\r\n    background-color: #003577;\r\n    color: #fff;\r\n}\r\n\r\n.apexcharts-legend-series {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    height: 20px;\r\n}\r\n\r\n.main-upgrade-guide {\r\n    height: 50px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    margin-top: 20px;\r\n}\r\n\r\n.main-upgrade-guide-input {\r\n    width: 600px;\r\n    border: 1px solid #d3d3d3;\r\n    padding: 10px;\r\n    outline: none;\r\n    border-radius: 5px;\r\n    font-size: 14px;\r\n    text-align: left\r\n}\r\n\r\n\r\n.upgrade-btn {\r\n    background-color: #e5e5e5;\r\n    border: 1px solid #d5d5d5;\r\n    border-radius: 5px;\r\n    padding: 0 10px;\r\n    height: 28px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.main-box {\r\n    padding-bottom: 50px;\r\n}\r\n\r\n.main-box-1 {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: flex-start;\r\n    gap: 50px;\r\n    padding-bottom: 50px;\r\n}\r\n\r\n.modal-flex {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n    gap: 30px;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.modal-body {\r\n    margin-bottom: 30px;\r\n}\r\n\r\n\r\n.modal-body-flex {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: flex-start;\r\n    gap: 10px;\r\n    text-align: left;\r\n}\r\n\r\n.table-overflow-hidden {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: block !important;\r\n}\r\n\r\nselect {\r\n    background-color: transparent;\r\n}\r\n\r\n.react-datepicker__input-container input {\r\n    width: 150px;\r\n    border: none;\r\n    outline: none;\r\n    background: inherit;\r\n    cursor: pointer;\r\n    text-align: center;\r\n    color: rgba(136, 136, 136, 1);\r\n    padding: 13px 12px 10px;\r\n    font-size: 14px;\r\n}\r\n\r\n.modal-3-1-left.dark .react-datepicker__input-container input {\r\n    color: #fff;\r\n}\r\n\r\n.modal-3-1-left-1.on .react-datepicker__input-container input {\r\n    color: #fff;\r\n}\r\n\r\n.modal-3-1-left-1:hover .react-datepicker__input-container input {\r\n    color: #fff;\r\n}\r\n\r\n.modal-3-1-left {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 5px;\r\n    height: 35px;\r\n}\r\n\r\n.modal-3-1-left-1 {\r\n    padding: 6px 12px;\r\n    background-color: rgba(237, 239, 241, 1);\r\n    color: rgba(136, 136, 136, 1);\r\n    border-radius: 5px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    height: 35px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.modal-3-1-left.dark .modal-3-1-left-1 {\r\n    background: #494848;\r\n    color: #fff;\r\n}\r\n\r\n.modal-3-1-left .modal-3-1-left-1.on {\r\n    background-color: #003577;\r\n    color: #fff;\r\n}\r\n\r\n.modal-3-1-left .modal-3-1-left-1:hover {\r\n    background-color: #003577;\r\n    color: #fff;\r\n}\r\n\r\n.excel {\r\n    width: 100%;\r\n    height: 32px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 10px;\r\n    margin: 30px 0 10px;\r\n    position: relative;\r\n}\r\n\r\n.excel-btn {\r\n    width: 130px;\r\n    height: 32px;\r\n    background-color: rgba(237, 239, 241, 1);\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: absolute;\r\n    right: 0;\r\n}\r\n\r\n.excel-btn:hover {\r\n    background-color: #003577;\r\n    color: #fff;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
